import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Typography } from '@chilecompra/react-kit/components'
import { AirlineLogo, NotAvailable, Row } from './HomeForm.styles'

/**
 * The AirlineCard's component.
 */
const AirlineCard = props => {
  const {
    enabled = false,
    logo = '',
    message = 'El proveedor se encuentra inhábil en el Registro de Proveedores.',
    name = '',
    url = '',
    onRedirectToUrl = () => undefined
  } = props

  const handleRedirectToUrl = useCallback(() => onRedirectToUrl(url), [onRedirectToUrl, url])

  return (
    <Card color="blank">
      <Row alignItems="center" justifyContent="center" padding="0 40px 40px">
        <AirlineLogo alt={name} src={logo} />
        {enabled && (
          <Button variant="outlined" color="primary" onClick={handleRedirectToUrl}>
            Cotizar y comprar pasajes
          </Button>
        )}
        {!enabled && (
          <NotAvailable>
            <Typography variant="body2">{message}</Typography>
          </NotAvailable>
        )}
      </Row>
    </Card>
  )
}

AirlineCard.propTypes = {
  enabled: PropTypes.bool,
  logo: PropTypes.string,
  message: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
  onRedirectToUrl: PropTypes.func
}

export default AirlineCard
